// Pure formatting for the notifications bell (tested in
// notificationFormat.test.ts).

/** Badge text: exact up to 99, then "99+". Empty for zero. */
export function unreadBadgeText(count: number): string {
  if (count <= 0) return '';
  return count > 99 ? '99+' : String(count);
}

/** Screen-reader label for the bell button. */
export function bellAriaLabel(count: number): string {
  if (count <= 0) return 'Notifications';
  if (count > 99) return 'Notifications, more than 99 unread';
  return `Notifications, ${count} unread`;
}

const MINUTE = 60_000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

/** Short relative time: "Just now", "5m ago", "3h ago", "2d ago", then a
 *  date ("Oct 3", or "Oct 3, 2025" outside the current year). */
export function relativeTime(at: number, now: number = Date.now()): string {
  const diff = Math.max(0, now - at);
  if (diff < MINUTE) return 'Just now';
  if (diff < HOUR) return `${Math.floor(diff / MINUTE)}m ago`;
  if (diff < DAY) return `${Math.floor(diff / HOUR)}h ago`;
  if (diff < 7 * DAY) return `${Math.floor(diff / DAY)}d ago`;
  const d = new Date(at);
  const sameYear = d.getFullYear() === new Date(now).getFullYear();
  return d.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    ...(sameYear ? {} : { year: 'numeric' }),
  });
}

/** Support reference from an API error message ("…contact support with
 *  reference ab12cd34."), so the panel can show it without showing the
 *  raw message. Raw error text never reaches the customer. */
export function supportReference(message: string | null | undefined): string | null {
  const m = /reference ([a-f0-9]{8})\b/i.exec(message ?? '');
  return m ? m[1] : null;
}
